export interface ColumnSettings {
  key: string;
  visible: boolean;
  order: number;
}

export interface MaintenanceLogSettingsState {
  columnSettings: ColumnSettings[];
}

export const maintenanceLogSettingsInitialState: MaintenanceLogSettingsState = {
  columnSettings: [
    { key: 'status', visible: true, order: 0 },
    { key: 'company', visible: true, order: 1 },
    { key: 'department', visible: true, order: 2 },
    { key: 'forklift', visible: true, order: 3 },
    { key: 'maintenanceDate', visible: true, order: 4 },
    { key: 'type', visible: true, order: 5 },
    { key: 'technician', visible: true, order: 6 },
    { key: 'invoicedCompany', visible: true, order: 7 },
    { key: 'description', visible: true, order: 8 },
    { key: 'cost', visible: true, order: 9 },
    { key: 'counter', visible: true, order: 10 },
    { key: 'nextMaintenanceDate', visible: true, order: 11 },
    { key: 'replacementVehicle', visible: true, order: 12 },
    { key: 'expectedMaintenanceEndDateTime', visible: true, order: 13 },
    { key: 'maintenanceEndDateTime', visible: true, order: 14 },
    { key: 'maintenanceTime', visible: true, order: 15 },
    { key: 'actions', visible: true, order: 16 },
  ],
};
